import { RESET_STORE_OPENED_CLAIMS } from 'containers/LoginPage/constants';
import {
  REQUEST_MANAGER_OPENED_CLAIMS,
  REQUEST_SAGIS_LAWYER_ASSIGNED_CLAIMS,
  SET_MANAGER_OPENED_CLAIMS,
  SET_SAGIS_LAWYER_ASSIGNED_CLAIMS,
} from 'containers/ManagerOpenedClaimsPage/constants';

export const requestManagerOpenedClaims = (
  status: string,
  page: number,
  pageSize: number,
) => ({
  type: REQUEST_MANAGER_OPENED_CLAIMS,
  status,
  page,
  pageSize,
});

export const setManagerOpenedClaims = (response: any) => ({
  type: SET_MANAGER_OPENED_CLAIMS,
  response,
});

export const resetManagerOpenedClaims = () => ({
  type: RESET_STORE_OPENED_CLAIMS,
});

export const requestSagisLawyerAssignedClaims = (claimNumbers: string[]) => ({
  type: REQUEST_SAGIS_LAWYER_ASSIGNED_CLAIMS,
  claimNumbers,
});

export const setSagisLawyerAssignedClaims = (response: any) => ({
  type: SET_SAGIS_LAWYER_ASSIGNED_CLAIMS,
  response,
});
